import React from 'react';
import { Link } from 'react-router-dom';

const FooterNewsRoomItems = () => {

    const items = [

        {
            type: 'footerItem',
            icon: '',
            text: 'Career',
            link: '/career'
        }

    ];

    const showItems = () => {
        return items.map((item, i) => (
            <div key={i} className={item.type}>
                <Link to={item.link}>
                    {item.text}
                </Link>
            </div>
        ))
    }
    return (
        <div>

            <h3>
                NEWSROOM
            </h3>
            {showItems()}
        </div>
    );
};

export default FooterNewsRoomItems;